import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=61fe36a1&"
import script from "./TheButton.vue?vue&type=script&lang=js&"
export * from "./TheButton.vue?vue&type=script&lang=js&"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=61fe36a1&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports